// import React from 'react';
// import '../styles/copilotApproach.css';

// const CopilotApproach = () => {
//     const approachSteps = [
//         { title: "Secure access and Zero Trust controls", desc: "Ensuring identity-centric security for every AI interaction." },
//         { title: "Clean, governed Microsoft 365 data", desc: "Organizing data structures to prevent oversharing and data leakage." },
//         { title: "Compliance-ready AI usage", desc: "Aligning AI operations with industry-specific regulatory standards." },
//         { title: "High adoption across teams", desc: "Tailored enablement programs to ensure teams actually use and love the tool." },
//         { title: "Long-term value and scalability", desc: "Building a foundation that grows as your AI needs evolve." }
//     ];

//     return (
//         <section className="approach-section">
//             <div className="approach-container">
//                 <div className="approach-header">
//                     <h2 className="approach-heading">The Synectiks Approach to Copilot Enablement</h2>
//                     <p className="approach-intro">
//                         Copilot works across your organization’s data, identity, and collaboration environment. 
//                         That means adoption must be intentional. Synectiks delivers Copilot through a proven framework designed to ensure:
//                     </p>
//                 </div>

//                 <div className="approach-grid">
//                     {approachSteps.map((step, index) => (
//                         <div className="approach-card" key={index}>
//                             <div className="approach-icon-wrap">
//                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//                                     <polyline points="20 6 9 17 4 12"></polyline>
//                                 </svg>
//                             </div>
//                             <div className="approach-text">
//                                 <h4 className="approach-card-title">{step.title}</h4>
//                                 <p className="approach-card-desc">{step.desc}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 <div className="approach-footer">
//                     <p className="highlight-text">We don’t just deploy Copilot. <span className="highlight-sub">We operationalize AI for the modern workplace.</span></p>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CopilotApproach;











import React from 'react';
import '../styles/copilotApproach.css';

const CopilotApproach = () => {
    const approachSteps = [
        { title: "Secure access and Zero Trust controls", desc: "Ensuring identity-centric security for every AI interaction." },
        { title: "Clean, governed Microsoft 365 data", desc: "Organizing data structures to prevent oversharing and data leakage." },
        { title: "Compliance-ready AI usage", desc: "Aligning AI operations with industry-specific regulatory standards." },
        { title: "High adoption across teams", desc: "Tailored enablement programs to ensure teams actually use and love the tool." },
        { title: "Long-term value and scalability", desc: "Building a foundation that grows as your AI needs evolve." }
    ];

    return (
        <section className="approach-section">
            <div className="approach-container">
                <div className="approach-header">
                    <h2 className="approach-heading">The Synectiks Approach to Copilot Enablement</h2>
                    <p className="approach-intro">
                        Copilot works across your organization’s data, identity, and collaboration environment. 
                        That means adoption must be intentional.
                    </p>
                </div>

                {/* Using a flex container instead of a strict grid to prevent glitches */}
                <div className="approach-flex-wrapper">
                    {approachSteps.map((step, index) => (
                        <div className="approach-card-uniform" key={index}>
                            <div className="approach-icon-wrap">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <div className="approach-text">
                                <h4 className="approach-card-title">{step.title}</h4>
                                <p className="approach-card-desc">{step.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="approach-footer">
                    <p className="highlight-text">
                        We don’t just deploy Copilot. 
                        <span className="highlight-sub"> We operationalize AI for the modern workplace.</span>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CopilotApproach;